import { Button } from "reactstrap";
import { getLeftAlignCell } from "../Helpers/GenericListHelpers/genericListElements";

export const emptyProjectData = {
  organization: {
    fiscalCode: "",
    description: "",
    organizationLongDescription: "",
    legalRepresentativeName: "",
    legalRepresentativeSurname: "",
  },
  cup: "",
  coFinancing: "",
  fiscalCode: "",
};

export const organizationFiscalCodeColumn = {
  Header: "Codice Fiscale",
  accessor: "fiscalCode",
  type: {
    name: "String",
    kind: "SCALAR",
    ofType: null,
  },
  Cell: (row) => getLeftAlignCell(row),
};

export const getManageUserColumn = (redirectToUsersPage) => ({
  Header: "",
  accessor: "manageUser",
  sortable: false,
  enableColumnFilter: false,
  type: { name: "manageUser" },
  Cell: ({ row }) =>
    !row.original.organization?.isExternal ? null : (
      <Button
        color="info"
        // className={styles.btn}
        onClick={() =>
          redirectToUsersPage(row.original.organization?.instituteCode)
        }
      >
        Utente
      </Button>
    ),
});

export const getModifyColumn = (setProjectData, toggleModalState) => ({
  accessor: "modify",
  enableColumnFilter: false,
  Cell: ({ row }) => (
    <Button
      onClick={() => {
        setProjectData(row.original);
        toggleModalState(true);
      }}
    >
      Mod.
    </Button>
  ),
});

export const getOrganizationDataToSave = (values, projectId) => ({
  projectId: projectId,
  fiscalCode: values.organization.fiscalCode.trim(),
  instituteCode: values.organization.fiscalCode.trim(),
  description: values.organization.description,
  longDescription: values.organization.longDescription,
  legalRepresentativeName: values.organization.legalRepresentativeName,
  legalRepresentativeSurname: values.organization.legalRepresentativeSurname,
});

export const getProjectUnitDataToSave = (
  values,
  projectId,
  existingOrganization
) => ({
  projectId: projectId,
  coFinancing: values.coFinancing,
  cup: values.cup,
  organizationId: existingOrganization.id,
});
